// 带有排序的所有银行的授权指引，部分文件可能不存在，仅作排序使用
export default {
  "1": "中国工商银行股份有限公司 (ICBC)",
  "2": "中国银行股份有限公司 (BOC)",
  "3": "中国建设银行股份有限公司 (CCB)",
  "4": "中国农业银行股份有限公司 (ABC)",
  "5": "招商银行股份有限公司 (CMB)",
  "6": "中信银行股份有限公司 (CITIC)",
  "7": "交通银行股份有限公司 (BOCOM)",
  "8": "上海浦东发展银行股份有限公司 (SPD Bank)",
  "9": "兴业银行股份有限公司 (CIB)",
  "10": "中国民生银行股份有限公司 (CMBC)",
  "11": "中国光大银行股份有限公司 (CEB)",
  "12": "汇丰银行（中国）有限公司 (HSBC)",
  "13": "平安银行股份有限公司 (Ping An Bank)",
  "14": "中国邮政储蓄银行股份有限公司 (PSBC)",
  "15": "广发银行股份有限公司 (CGB)",
  "16": "浙商银行股份有限公司 (CZB)",
  "17": "宁波银行股份有限公司 (Bank of Ningbo)",
  "18": "华夏银行股份有限公司 (Huaxia Bank)",
  "19": "北京银行股份有限公司 (Bank of Beijing)",
  "20": "江苏银行股份有限公司 (Bank of Jiangsu)",
  "21": "南京银行股份有限公司 (Bank of Nanjing)",
  "22": "广州银行股份有限公司 (Bank of Guangzhou)",
  "23": "广东华兴银行股份有限公司 (GHB)",
  "24": "齐鲁银行股份有限公司 (Qilu Bank)",
  "25": "广东南粤银行股份有限公司 (Guangdong Nanyue Bank)",
  "26": "威海市商业银行股份有限公司 (Weihai Bank)",
  "27": "莱商银行股份有限公司 (Laishang Bank)",
  "28": "浙江民泰商业银行股份有限公司 (Zhejiang Mintai Commercial Bank)",
  "29": "日照银行股份有限公司 (Bank of Rizhao)",
  "30": "潍坊银行股份有限公司 (Bank of Weifang)",
  "31": "德州银行股份有限公司 (Dezhou Bank)",
  "32": "无锡锡商银行股份有限公司 (Wuxi Xishang Bank)",
  "33": "广州汽车集团财务有限公司 (GAC Finance)",
  "34": "济宁儒商村镇银行股份有限公司 (Jining Rushang Rural Bank)",
  "35": "杭州银行股份有限公司 (Bank of Hangzhou)",
  "36": "国家开发银行 (China Development Bank)",
  "37": "渤海银行股份有限公司 (China Bohai Bank)",
  "38": "中国进出口银行 (The Export - Import Bank of China)",
  "39": "中国农业发展银行 (ADBC)",
  "40": "徽商银行股份有限公司 (Huishang Bank)",
  "41": "上海农村商业银行股份有限公司 (SHRCB)",
  "42": "厦门国际银行股份有限公司 (Xiamen International Bank)",
  "43": "东亚银行（中国）有限公司 (BEA)",
  "44": "浙江网商银行股份有限公司 (Zhejiang Wangshang Bank)",
  "45": "苏州银行股份有限公司 (Bank of Suzhou)",
  "46": "青岛银行股份有限公司 (BQD)",
  "47": "昆仑银行股份有限公司 (Bank of Kunlun)",
  "48": "韩亚银行（中国）有限公司 (1Q Bank)",
  "49": "重庆银行股份有限公司 (Bank of Chongqing)",
  "50": "北京中关村银行股份有限公司 (Zhongguancun Bank)",
  "51": "四川新网银行股份有限公司 (SICHUAN XW BANK)",
  "52": "宁波通商银行股份有限公司 (Ningbo Commerce Bank)",
  "53": "深圳前海微众银行股份有限公司 (WeBank)",
  "54": "天津农村商业银行股份有限公司 (TRC Bank)",
  "55": "哈尔滨银行股份有限公司 (Haerbin Bank)",
  "56": "河北银行股份有限公司 (Bank of Hebei)",
  "57": "中信百信银行股份有限公司 (CITIC AIBank)",
  "58": "广州农村商业银行股份有限公司 (Guangzhou Rural Commercial Bank)",
  "59": "东方汇理银行（中国）有限公司 (CA-CIB)",
  "60": "贵州银行股份有限公司 (Bank of Guizhou)",
  "61": "内蒙古银行股份有限公司 (Bank of Inner Mongolia)",
  "62": "鄂尔多斯银行股份有限公司 (ORDOS Bank)",
  "63": "西安银行股份有限公司 (Bank of Xi'an)",
  "64": "龙江银行股份有限公司 (Longjiang Bank)",
  "65": "广西北部湾银行股份有限公司 (Guangxi Beibu Gulf Bank)",
  "66": "宁夏银行股份有限公司 (Bank of Ningxia)",
  "67": "齐商银行股份有限公司 (Qishang Bank)",
  "68": "烟台银行股份有限公司 (Yantai Bank)",
  "69": "福建海峡银行股份有限公司 (Haixia Bank of Fujian)",
  "70": "甘肃银行股份有限公司 (Bank of Gansu)",
  "71": "临商银行股份有限公司 (Linshang Bank)",
  "72": "吉林亿联银行股份有限公司 (Yillion Bank)",
  "73": "威海蓝海银行股份有限公司 (Blue Ocean Bank)",
  "74": "绍兴银行股份有限公司 (BSX)",
  "75": "宜宾市商业银行股份有限公司 (Yibin City Commercial Bank)",
  "76": "东营银行股份有限公司 (Dongying Bank)",
  "77": "华侨银行有限公司 (OCBC)",
  "78": "湖南三湘银行股份有限公司 (Bank of Sanxiang)",
  "79": "石嘴山银行股份有限公司 (Bank of Shizuishan)",
  "80": "泰安银行股份有限公司 (Taian Bank)",
  "81": "达州银行股份有限公司 (Bank of Dazhou)",
  "82": "遂宁银行股份有限公司 (Suining Bank)",
  "83": "唐山银行股份有限公司 (BOTS)",
  "84": "济宁银行股份有限公司 (Bank of Jining)",
  "85": "新疆汇和银行股份有限公司 (Xinjiang Huihe Bank)",
  "86": "雅安市商业银行股份有限公司 (Yaan City Commercial Bank)",
  "87": "宁波东海银行股份有限公司 (Ningbo Donghai Bank)",
  "88": "江西裕民银行股份有限公司 (Jiangxi Yumin Bank)",
  "89": "重庆璧山工银村镇银行有限责任公司 (Chongqing Bishan Industrial and Commercial Bank of China Rural Bank)",
  "90": "东营莱商村镇银行股份有限公司 (Dongying Laishang Rural Bank)",
  "91": "宜宾兴宜村镇银行有限责任公司 (Yibin Xingyi Rural Bank)",
  "92": "海尔集团财务有限责任公司 (Haier)",
  "93": "林芝民生村镇银行股份有限公司 (Linzhi Minsheng Rural Bank)",
  "94": "内江兴隆村镇银行股份有限公司 (Neijiang XingLong Rural Bank)",
  "95": "珠海格力集团财务有限责任公司 (Gree Finance)",
  "96": "四川江油华夏村镇银行股份有限公司 (Sichuan Jiangyou Huaxia Rural Bank)",
  "97": "天津武清村镇银行股份有限公司 (Tianjin Wuqing County Bank)",
  "98": "盘锦银行股份有限公司 (Bank of Panjin)",
  "99": "乐山市商业银行股份有限公司 (Leshan City Commercial Bank)",
  "100": "上海嘉定洪都村镇银行股份有限公司 (Shanghai Jiading Hongdu Rural Bank)",
  "101": "梅州客家村镇银行股份公司 (Meizhou Hakka County Bank)",
  "102": "乐山嘉州民富村镇银行有限责任公司 (Leshan Jiazhou Minfu Rural Bank)",
  "103": "上海嘉定民生村镇银行股份有限公司 (Shanghai Jiading Minsheng Rural Bank)",
  "104": "海信集团财务有限公司 (Hisense)",
  "105": "贵州省农村信用社联合社 (Guizhou Rural Credit Union)",
  "106": "曲靖惠民村镇银行股份有限公司 (Qujing Huimin Village Bank)",
  "107": "上海松江民生村镇银行股份有限公司 (Songjiang Minsheng Village Bank)",
  "108": "厦门国贸控股集团财务有限公司 (ITG)",
  "109": "楚雄红塔村镇银行股份有限公司 (Chuxiong Hongta Village Bank)",
  "110": "保定银行股份有限公司 (Bank of Baoding)",
  "111": "上饶银行股份有限公司 (Bank of Shangrao)",
  "112": "海南银行股份有限公司 (Bank of Hainan)",
  "113": "重庆三峡银行 (Chongqing Three Gorges Bank)",
  "114": "云南红塔银行股份有限公司 (Yunnan Hongta Bank)",
  "115": "彰银商业银行 (Changyin Commercial Bank)",
  "116": "浙江泰隆商业银行 (Tailong Commercial Bank)",
  "117": "江苏苏商银行股份有限公司 (SMB)",
  "118": "平凉市静宁成纪村镇银行 (Pingliang Jingning Chengji Village Bank)",
  "119": "中核财务有限责任公司 (CNNC)",
  "120": "招商局集团财务有限公司 (China Merchants Group Finance Co., LTD.)",
  "121": "通用技术集团财务有限责任公司 (Genertec Finance)",
  "122": "山东港口集团财务有限责任公司 (Shandong Port Group)",
  "123": "宝武集团财务有限责任公司 (Baowu)",
  "124": "一汽财务有限公司 (First Automobile Finance)",
  "125": "Client Authorization Instructions (Confirmation.com)",
  "126": "澳门国际银行股份有限公司 (LUSO INTERNATIONAL BANKING LTD.)",
  "127": "南方电网财务有限公司 (China Southern Power Grid Corporation Finance Co., Ltd.)",
  "128": "特变电工集团财务有限公司 (TBEA Co., Ltd.)",
  "129": "星展银行（中国）有限公司 (DBS Bank China Ltd)",
  "130": "中银富登村镇银行 (BOC Fullerton Community Bank)"
}